import { generateClasses, toggleDialog } from "../../utils";

export const handleSearch = () => {
  const searchTriggers = document.querySelectorAll("[data-search-trigger]")!;
  const searchDialog = document.querySelector("[data-search]")!;
  const searchDialogCloser = searchDialog.querySelector("[data-close]");
  const searchDialogInput = searchDialog.querySelector("input");

  for (const t of searchTriggers) {
    t.addEventListener("click", () => {
      toggleDialog(
        searchDialog,
        true,
        generateClasses(true, "opacity-100", "opacity-0"),
      );

      console.log(searchDialogInput);
      setTimeout(() => {
        searchDialogInput?.focus();
      }, 50);
    });
  }

  searchDialogCloser?.addEventListener("click", () => {
    toggleDialog(
      searchDialog,
      false,
      generateClasses(false, "opacity-100", "opacity-0"),
    );
  });
};
